import React, { useState } from "react";

import Box from "./Box";
import Button from "./Button";
import ChevronIcon from "../assets/chevron.svg";
import PropTypes from "prop-types";
import SmallCaps from "./SmallCaps";

function CategoryLearnMore({ content }) {
  const [active, setActive] = useState(false);
  return (
    <Box>
      <Button
        width={125}
        onClick={() => setActive(!active)}
        py={[20, null, 30, null]}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pl="5px"
        >
          <SmallCaps>Learn more</SmallCaps>
          <Box
            transform={active ? "rotate(90deg)" : "rotate(270deg)"}
            display="flex"
            alignItems="center"
          >
            <ChevronIcon aria-label="Arrow" />
          </Box>
        </Box>
      </Button>
      {active && (
        <Box pb={[20, null, 30, null]} pr={[20, null, 80, null]}>
          {content}
        </Box>
      )}
    </Box>
  );
}

export default CategoryLearnMore;

CategoryLearnMore.propTypes = {
  content: PropTypes.node.isRequired,
};
